import moment from 'moment';

export const templateInitialValues = {
	complaints: [
		{
			id: 1,
			complaintId: '',
			frequencyId: '',
			severityId: '',
			durationId: '',
			date: '',
			complaintName: '',
			frequencyName: '',
			severityName: '',
			durationName: '',
			existingVisitComplaintId: null,
		},
	],
	diagnosis: [
		{ id: 1, diagnosisId: '', durationId: '', date: '', diagnosisName: '', durationName: '', existingVisitDiagnosisId: null },
	],
	rx: [
		{ id: 1, medicineId: '', doseId: '', timingId: '', frequencyId: '', durationId: '', medicineName: '', doseName: '', timingName: '', frequencyName: '', durationName: '', note: '', existingVisitMedicineId: null },
	],
};

export const setTemplateInitialValues = (type, selectedTemplate) => {
	if (type === 'complaint') {
		const newValues = {
			complaints: selectedTemplate.complaintItems.map((complaint, index) => ({
				id: index + 1,
				complaintId: complaint.complaint_id,
				frequencyId: complaint.frequency_id,
				severityId: complaint.severity_id,
				durationId: complaint.duration_id,
				date: moment(complaint.date).format('YYYY-MM-DD'),
				existingVisitComplaintId: complaint.id,
				existingTemplateId: selectedTemplate.id,
				existingTemplateItemId: complaint.id,
			})),
		};
		return newValues;
	} else if (type === 'diagnosis') {
		const newValues = {
			diagnosis: selectedTemplate.diagnosisItems.map((diagnosis, index) => ({
				id: index + 1,
				diagnosisId: diagnosis.diagnosis_id,
				durationId: diagnosis.duration_id,
				date: moment(diagnosis.date).format('YYYY-MM-DD'),
				existingVisitDiagnosisId: diagnosis.id,
				existingTemplateId: selectedTemplate.id,
				existingTemplateItemId: diagnosis.id,
			})),
		};
		return newValues;
	} else if (type === 'prescription') {
		const newValues = {
			rx: selectedTemplate.prescriptionItems.map((rx, index) => ({
				id: index + 1,
				medicineId: rx.medicine_id,
				doseId: rx.dose_id,
				timingId: rx.timing_id,
				frequencyId: rx.frequency_id,
				durationId: rx.duration_id,
				note: rx.notes || '',
				existingVisitMedicineId: rx.id,
				existingTemplateId: selectedTemplate.id,
				existingTemplateItemId: rx.id,
			})),
		};
		return newValues;
	} else {
		return {};
	}
};